<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="用户名"></el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" v-on:click="getUsers">查询</el-button>
        </el-form-item>
        <el-form-item v-if="isSuperAdmin">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%;"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="name" label="用户名"></el-table-column>
      <el-table-column
        prop="role"
        label="角色"
        :formatter="formatRole"
      ></el-table-column>
      <el-table-column
        prop="openId"
        label="openId"
        width="400"
      ></el-table-column>

      <el-table-column label="操作" width="150">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="handleDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="用户名" prop="name">
          <el-input
            disabled
            v-model="editForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="editForm.password"
            placeholder="不填则不变"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="editForm.role">
            <el-option label="超级管理员" :value="0"></el-option>
            <el-option label="普通管理员" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="openId" prop="openId">
          <el-input v-model="editForm.openId" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="用户名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="addForm.role">
            <el-option label="超级管理员" :value="0"></el-option>
            <el-option label="普通管理员" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="openId" prop="openId">
          <el-input v-model="addForm.openId" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util';
  import NProgress from 'nprogress';
  import { adminApi } from '../../api/api';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        filters: {
          name: '',
        },
        users: [],
        total: 0,
        page: 1,
        listLoading: false,
        sels: [], //列表选中列

        editFormVisible: false, //编辑界面是否显示
        editLoading: false,
        editFormRules: {
          //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
        },
        //编辑界面数据
        editForm: {
          name: '',
          password: '',
          role: '',
          id: '',
          openId: '',
        },

        addFormVisible: false, //新增界面是否显示
        addLoading: false,
        addFormRules: {
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
        },
        //新增界面数据
        addForm: {
          name: '',
          password: '',
          role: 1,
          openId: '',
        },
      };
    },
    methods: {
      //性别显示转换
      formatRole: function(row, column) {
        return row.role == 0 ? '超级管理员' : '普通管理员';
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getUsers();
      },
      //获取用户列表
      getUsers() {
        let para = {
          page: this.page,
        };
        this.listLoading = true;
        NProgress.start();
        adminApi.list(para).then(res => {
          this.total = res.data.count;
          this.users = res.data.rows;
          this.listLoading = false;
          NProgress.done();
        });
      },
      //删除
      handleDel: function(index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning',
        })
          .then(() => {
            this.listLoading = true;
            NProgress.start();
            let para = { id: row.id };
            adminApi.del(para).then(res => {
              this.listLoading = false;
              NProgress.done();
              this.$message({
                message: '删除成功',
                type: 'success',
              });
              this.getUsers();
            });
          })
          .catch(() => {});
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign(this.editForm, row);
      },
      //显示新增界面
      handleAdd: function() {
        this.addFormVisible = true;
        this.addForm = {
          name: '',
          password: '',
          role: 0,
        };
      },
      //编辑
      editSubmit: function() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              adminApi.update(para).then(res => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success',
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getUsers();
              });
            });
          }
        });
      },
      //新增
      addSubmit: function() {
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              //   para.birth =
              //     !para.birth || para.birth == ''
              //       ? ''
              //       : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
              adminApi.add(para).then(res => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success',
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getUsers();
              });
            });
          }
        });
      },
      selsChange: function(sels) {
        this.sels = sels;
      },
      //批量删除
      batchRemove: function() {
        var ids = this.sels.map(item => item.id).toString();
        this.$confirm('确认删除选中记录吗？', '提示', {
          type: 'warning',
        })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = { ids: ids };
            batchRemoveUser(para).then(res => {
              this.listLoading = false;
              //NProgress.done();
              this.$message({
                message: '删除成功',
                type: 'success',
              });
              this.getUsers();
            });
          })
          .catch(() => {});
      },
    },
    mounted() {
      this.getUsers();
    },
    computed: {
      ...mapGetters(['getUserInfo', 'isSuperAdmin']),
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// index.vue?3feac326